import React, { useState, useEffect, useContext, memo } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import TabHeader from "components/MBM/TabHeader";
import MBMTabs from "components/MBM/MBMTabs";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import { makeStyles } from "@mui/styles";
import  Workspace from "components/MITM/GEIT/Workspace";
import postPageVisit from "services/LogService";

const useStyles = makeStyles((theme) => ({
  cardbody: {
    padding: 0,
  },
  card: {
    padding: 0,
    marginTop: 10,
    marginBottom: 10,
  },
}));

function GEIT() {
  const classes = useStyles();
  const [redirState, setRedirState] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setPage, selectedNodesInfo } = appContext;

  useEffect(() => {
    setPage('geb');
    postPageVisit('geb');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/geb",
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"geb"}
    >
      <Workspace />
      {redirecting}
    </ErrorBoundary>
  );
}

export default GEIT;
